import Ng from './Ng';

export default {
    path: 'ng',
    name: 'ng',
    component: Ng,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-ng/index.js